import React, { useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress, Chip, Typography } from '@mui/material';

interface CancelDialogProps {
  open: boolean;
  onClose: () => void;
  campaign: any;
}

const MIN_LENGTH = 3;
const MAX_LENGTH = 500;

const CancelDialog: React.FC<CancelDialogProps> = ({ open, onClose, campaign }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  if (!campaign) return null;
  const invalid = reason.trim().length < MIN_LENGTH || reason.length > MAX_LENGTH;

  const handleConfirm = async () => {
    if (invalid) return;
    setLoading(true);
    try {
      await dataProvider.create(`customer-recovery-rules/${campaign.id}/cancel`, { data: { reason } });
      notify('Campanha encerrada', { type: 'success' });
      refresh();
      setReason('');
      onClose();
    } catch (error: any) {
      notify(error.message || 'Erro ao encerrar a campanha', { type: 'warning' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !loading && onClose()} fullWidth maxWidth="sm">
      <DialogTitle>Encerrar campanha</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Os cupons dos clientes que ainda não voltaram são apagados e a campanha para de mandar mensagem.
        </Typography>
        <Chip label={`${campaign.activeCount ?? 0} cliente(s) ativos afetados`} color="warning" sx={{ mb: 2 }} />
        <TextField
          label="Motivo"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          fullWidth
          multiline
          rows={3}
          autoFocus
          error={reason.length > 0 && invalid}
          helperText={`${reason.length}/${MAX_LENGTH} — mínimo de ${MIN_LENGTH} caracteres`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button
          variant="contained"
          color="error"
          disabled={loading || invalid}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}
          onClick={handleConfirm}
        >
          Encerrar campanha
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
